import axios from "axios";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import useSWR from "swr";
import Api from "../../../../../../../initialpage/hooks/Api";
import useAuth from "../../../../../../../initialpage/hooks/useAuth";
import NotFoundPage from "../../../../../StoreComponents/NotFoundPage";
import { API } from "../../../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../../../StoreComponents/hooks/useStoreLog";
import Cookies from "js-cookie";
import moment from "moment";
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const UpdateViewMrr = () => {
  const user = JSON.parse(Cookies.get("user") || '{}');
  //  console.log(user)
  const navigate = useNavigate();
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [mrrGetById, setMrrGetById] = useState({});
  const { info } = useParams();
  const myArray = info.split("&");

  // get supplierData
  const { data: supplierOption, error: error1 } = useSWR(
    `store/settings/suppliers?page=${0}&limit=${10000}`,
    fetcher1
  );
  // get viewMrrSlip Data
  const {
    data: viewMrrSlip,
    error,
    mutate,
  } = useSWR(
    myArray[1] && myArray[0] && myArray[2]
      ? `store/mrr/productrecept/${myArray[1]}/${myArray[0]}/${myArray[2]}`
      : null,
    fetcher
  );

  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();
  const {
    register: register,
    reset: reset,
    formState: { errors: errors },
    handleSubmit: handleSubmit,
  } = useForm();

  const onSubmitUpdate1 = (data) => {
    data.prolistid = mrrGetById.PROLISTID;
    data.proid = mrrGetById.PROID;
    data.proqty = mrrGetById.PROQTY;
    data.oldquantity = mrrGetById.QUANTITIES;
    data.oldamount = mrrGetById.PROAMOUNT;
    data.change_status = data.change_status;
    data.newquantity = parseFloat(data.newquantity);
    data.newamount = parseFloat(data.newamount);
    data.username = user ? user?.name_english : "";
    console.log(data);

    API.put("store/mrr/singleProductEntriList", data).then((res) => {
      console.log(res.data);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Update",
          icon: "success",
          button: "Ok",
        });

        PostStoreLog(2, "Mrr Product update");
        window.$("#edit_product").modal("hide");
        reset();
        mutate();
      }
    });
  };



  //   Update supliers
  const onSubmitUpdate = (data) => {
    if (selectedSupplier) {
      data.supplier = selectedSupplier.value;
    } else {
      data.supplier = viewMrrSlip.entriesInfo.supplier;
    }
    if (!data.suppdate) {
      data.suppdate = viewMrrSlip.entriesInfo.SUPPDATE;
    }
    if (!data.cashmemono) {
      data.cashmemono = viewMrrSlip.entriesInfo.cashmemono;
    }
    if (!data.cashmemodate) {
      data.cashmemodate = viewMrrSlip.entriesInfo.CASHMEMODATE;
    }
    if (!data.workodate) {
      data.workodate = viewMrrSlip.entriesInfo.WORKODATE;
    }
    if (!data.workorder) {
      data.workorder = viewMrrSlip.entriesInfo.workorder;
    }

    data.mrrno = parseInt(myArray[0]);
    console.log(data);

    API.put("store/mrr/productEntriesByMrrno", data).then((res) => {
      //console.log(res.data);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Update",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(2, "Mrr details update");
        window.location.replace(
          `/store/editproductreceipt/${myArray[0]}&${selectedSupplier.value
            ? selectedSupplier.value
            : viewMrrSlip.entriesInfo.supplier
          }&${myArray[2]}`
        );
        window.$("#edit_mrr").modal("hide");
        reset1();
        mutate();
      }
    });
  };

  const handleUpdate = (prolistId, proId) => {
    // console.log(prolistId,proId);
    API.get(
      proId && prolistId
        ? `store/mrr/getSingleEntry/${proId}/${prolistId}`
        : null
    ).then((res) => {
      setMrrGetById(res.data.data);
    });
  };

  // set supplier category select list
  let supplierCategory = [];
  if (supplierOption && supplierOption.length > 0) {
    supplierCategory = supplierOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.sup_id;
      optionsItem.label = `${data.supplier}`;
      return optionsItem;
    });
  }
  // handle supplier select;
  const handleSupplier = (name) => {
    setSelectedSupplier(name);
  };

  const deleteButtonHandler = (
    PROLISTID,
    PROID,
    PROQTY,
    QUANTITIES,
    PROAMOUNT,
    PRODENTRYBY
  ) => {
    const data = {
      prolistid: PROLISTID,
      proid: PROID,
      proqty: PROQTY,
      quantity: QUANTITIES,
      proamount: PROAMOUNT,
      username: PRODENTRYBY,
    };

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.delete("store/mrr/singleProductEntriList", { data }).then((res) => {
          //console.log(res);
          if (!res.data.error) {
            swal({
              title: "Thank You !",
              text: "Successfully Delete",
              icon: "success",
              button: "Ok",
            });
            PostStoreLog(3, "Delete Mrr Product");
            mutate();
          }
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>Requisition Details - BBA STORE</title>
        <meta name="description" content="Requisition Details - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      {!viewMrrSlip ? (
        <NotFoundPage />
      ) : (
        <div className="page-wrapper">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                className="btn btn-o ms-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i className="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>

          <section className=" mx-3 py-4">
            <div className="my-5">
              <>
                <div className="text-center mt-3">
                  <h3 className="fw-bold">
                    {" "}
                    Update Material Recipient Requirement (MRR)
                  </h3>
                  <h5 className="fw-bold">Entry Date: {myArray[2]}</h5>
                </div>

                <div className=" px-2 mt-5 py-4 d-flex justify-content-between">
                  <div className="text-start">
                    <h5 className="mb-3 text-start">
                      MRR No.:{" "}
                      <span style={{ color: "gray" }}>{myArray[0]}</span>
                    </h5>
                    <h5 className="text-start">
                      Supplier :{" "}
                      <span style={{ color: "gray" }}>
                        {viewMrrSlip.suppliers
                          ? viewMrrSlip.suppliers[0].supplier
                          : ""}
                      </span>
                    </h5>
                    <h5 className="text-start">
                      Work Order No:{" "}
                      <span style={{ color: "gray" }}>
                        {viewMrrSlip.entriesInfo
                          ? viewMrrSlip.entriesInfo.workorder
                          : ""}
                      </span>{" "}
                    </h5>
                    <h5 className="text-start">
                      Cash Memo / Bill / Challan No:{" "}
                      <span style={{ color: "gray" }}>
                        {" "}
                        {viewMrrSlip.entriesInfo
                          ? viewMrrSlip.entriesInfo.cashmemono?.split(" ")[0]
                          : ""}
                      </span>{" "}
                    </h5>
                  </div>
                  <div>
                    <h5 className="mb-3">
                      {" "}
                      <button
                        data-toggle="modal"
                        data-target="#edit_mrr"
                        className="btn btn-primary btn-o"
                        style={{ borderRadius: "10px" }}
                      >
                        <i className="fa fa-edit"></i> Edit Supplier Info
                      </button>
                    </h5>
                    <h5 className="">
                      Date :{" "}
                      <span style={{ color: "gray" }}>
                        {viewMrrSlip.entriesInfo
                          ? moment(
                            new Date(viewMrrSlip.entriesInfo.SUPPDATE)
                          ).format("DD/MM/YYYY")
                          : ""}
                      </span>
                    </h5>
                    <h5>
                      Date :{" "}
                      <span style={{ color: "gray" }}>
                        {viewMrrSlip.entriesInfo
                          ? moment(
                            new Date(viewMrrSlip.entriesInfo.WORKODATE)
                          ).format("DD/MM/YYYY")
                          : ""}
                      </span>{" "}
                    </h5>
                    <h5>
                      Date :{" "}
                      <span style={{ color: "gray" }}>
                        {viewMrrSlip.entriesInfo
                          ? moment(
                            new Date(viewMrrSlip.entriesInfo.CASHMEMODATE)
                          ).format("DD/MM/YYYY")
                          : ""}
                      </span>
                    </h5>
                  </div>
                </div>
              </>

              <div className="px-2 my-5">
                <table className="table table-bordered table-striped ">
                  <thead>
                    <tr
                      style={{
                        backgroundColor: "#3C8DBC",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      <th className="fw-bold col-design">S/N</th>
                      <th className="fw-bold col-design">Product</th>
                      <th className="fw-bold col-design"> Unit</th>
                      <th className="fw-bold col-design">Quantities</th>
                      <th className="fw-bold col-design">Price</th>
                      <th className="fw-bold col-design">Total Price</th>
                      <th className="fw-bold col-design">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewMrrSlip.entriLists &&
                      viewMrrSlip.entriLists.map((product, index) => (
                        <tr key={index}>
                          <td className="col-design text-center">{++index}</td>
                          <td className="col-design">{product.proname}</td>
                          <td className="col-design">{product.unit}</td>
                          <td className="col-design">
                            {parseInt(product.quantities)}
                          </td>
                          <td className="col-design">
                            {parseInt(product.proamount)}
                          </td>
                          <td className="col-design">
                            {parseInt(product.quantities) *
                              parseInt(product.proamount)}
                          </td>
                          <td className="text-center col-design">
                            <button
                              data-bs-toggle="tooltip"
                              title="Edit"
                              type="button"
                              data-toggle="modal"
                              data-target="#edit_product"
                              onClick={() => {
                                handleUpdate(product.prolistid, product.proid);
                              }}
                              className="btn btn-outline-color_store px-3 me-2"
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              data-bs-toggle="tooltip"
                              title="Delete"
                              type="button"
                              onClick={() => {
                                deleteButtonHandler(
                                  product.prolistid,
                                  product.proid,
                                  product.proqty,
                                  product.quantities,
                                  product.proamount,
                                  product.prodentryby
                                );
                              }}
                              className="btn btn-red_store px-3"
                            >
                              <i className="fa fa-trash-o"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/* Edit MRR Modal */}
          <div id="edit_mrr" className="modal custom-modal fade" role="dialog">
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Update Supplier Single Info</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                  </button>
                </div>
                <div className="modal-body text-start">
                  <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                    <div className="container px-4">
                      <div className="row gx-5">
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Supplier <span className="color-red">*</span>
                          </label>

                          <Select
                            onChange={handleSupplier}
                            placeholder={
                              viewMrrSlip.suppliers
                                ? viewMrrSlip.suppliers[0].supplier
                                : ""
                            }
                            style={{ borderRadius: "10px" }}
                            className="text-start"
                            options={supplierCategory}
                          />
                          <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0 }}
                            value={supplierCategory}
                            required
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Supplier Date<span className="color-red">*</span>
                          </label>

                          <input
                            type="date"
                            {...register1("suppdate")}
                            defaultValue={
                              viewMrrSlip.entriesInfo
                                ? viewMrrSlip.entriesInfo.SUPPDATE
                                : ""
                            }
                            className="input-field-new p-2"
                            required
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Work Order Number
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="text"
                            defaultValue={
                              viewMrrSlip.entriesInfo
                                ? viewMrrSlip.entriesInfo.workorder
                                : ""
                            }
                            {...register1("workorder")}
                            className="input-field-new p-2"
                            required
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Work Order Date<span className="color-red">*</span>
                          </label>

                          <input
                            type="date"
                            defaultValue={
                              viewMrrSlip.entriesInfo
                                ? viewMrrSlip.entriesInfo.WORKODATE
                                : ""
                            }
                            {...register1("workodate")}
                            className="input-field-new p-2"
                            required
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Cash Memo/Bill No.
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="text"
                            defaultValue={
                              viewMrrSlip.entriesInfo
                                ? viewMrrSlip.entriesInfo.cashmemono
                                : ""
                            }
                            {...register1("cashmemono")}
                            className="input-field-new p-2"
                            required
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Cash Memo/Bill Date{" "}
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="date"
                            defaultValue={
                              viewMrrSlip.entriesInfo
                                ? viewMrrSlip.entriesInfo.CASHMEMODATE
                                : ""
                            }
                            {...register1("cashmemodate")}
                            className="input-field-new p-2"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="submit-section">
                      <button
                        type="submit"
                        className="btn btn-color_store text-white px-5 py-2 rounded"
                      >
                        Update
                      </button>

                      <button
                        type="button"
                        className="btn btn-color_store text-white px-5 ms-1 py-2 rounded"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* Edit product Modal */}
          <div
            id="edit_product"
            className="modal custom-modal fade"
            role="dialog"
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Update MRR Product Info</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                  </button>
                </div>
                <div className="modal-body text-start">
                  <form onSubmit={handleSubmit(onSubmitUpdate1)}>
                    <div className="container px-4">
                      <div className="row gx-5">
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Change Status <span className="color-red">*</span>
                          </label>

                          <select
                            {...register("change_status", { required: true })}
                            class="form-select input-field-new p-2"
                            aria-label="Default select example"
                            required
                          >
                            <option value="">Select Status</option>
                            <option value="plus">Quantity Plus(+)</option>
                            <option value="minus">Quantity Minus(-)</option>
                            <option value="amount">Only Amount</option>
                          </select>
                        </div>

                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Current Stock
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="text"
                            defaultValue={mrrGetById ? mrrGetById.PROQTY : ""}
                            // {...register("proqty")}
                            className="input-field-new p-2"
                            disabled
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Existing MRR Quantity
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="text"
                            defaultValue={
                              mrrGetById ? mrrGetById.QUANTITIES : ""
                            }
                            disabled
                            className="input-field-new p-2"
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Existing MRR Amount
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="text"
                            disabled
                            defaultValue={
                              mrrGetById ? mrrGetById.PROAMOUNT : ""
                            }
                            className="input-field-new p-2"
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Change Quantity
                            <span className="color-red">*</span>
                          </label>

                          <input
                            step="0.01"
                            type="number"
                            {...register("newquantity", { required: true })}
                            className="input-field-new p-2"
                          />
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 mt-1">
                          <label htmlFor="Supplier">
                            Change Amount
                            <span className="color-red">*</span>
                          </label>

                          <input
                            type="number"
                            {...register("newamount", { required: true })}
                            defaultValue={
                              mrrGetById ? mrrGetById.PROAMOUNT : ""
                            }
                            className="input-field-new p-2"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="submit-section">
                      <button
                        type="submit"
                        className="btn btn-color_store text-white px-5 py-2 rounded"
                      >
                        Update
                      </button>

                      <button
                        type="button"
                        className="btn btn-color_store text-white px-5 ms-1 py-2 rounded"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateViewMrr;
